import {useAppSelector} from '../../store/store';
import styles from './navigation_dropup.module.scss';
import navStyles from './navigation.module.scss';
import {NavLink} from 'react-router-dom';
import {navLinkClass} from './navigation.tsx';
import {isAuthenticatedSelector} from '../../store/slices/exchange_token_slice.ts';
import React, {useCallback, useState} from 'react';
import {useClickOutside} from '../../support/use_click_outside.ts';
import {classNames} from '../../support/classnames.ts';
import {__} from '../../support/lang/translations.ts';

type OwnProps = {
    isActive: boolean;
};
export function NavigationDropup({isActive}: OwnProps) {
    const meInfo = useAppSelector((state) => state.customerInfo.me);
    const name = meInfo?.customer?.data?.find((d) => d?.key === 'name')?.value;
    const isAuthenticated = useAppSelector(isAuthenticatedSelector);

    const [isOpen, setIsOpen] = useState(false);

    const ref = React.useRef<HTMLDivElement | null>(null);
    const closePopupCallback = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    useClickOutside(ref, closePopupCallback);

    return (
        <div className={styles.nav__dropup} ref={ref}>
            <div
                className={classNames(styles.dropup__toggle, {
                    [styles.open]: isOpen,
                    [styles.active]: isActive,
                })}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className={styles.toggle__avatar}>
                    {meInfo?.customer?.profilePicture?.signed_url != null ? (
                        <img
                            src={meInfo.customer.profilePicture.signed_url}
                            alt={`Image ${name}`}
                            onError={(e) => (e.currentTarget.style.display = 'none')}
                        />
                    ) : (
                        <span className="fa-user"></span>
                    )}
                </div>

                <span>{name ?? __('nav.dropup.anonymous')}</span>

                <i className="fa-light fa-chevron-up"></i>
            </div>
            <div className={`${styles.dropup__menu} ${isOpen ? styles.open : null}`}>
                {isAuthenticated ? (
                    <>
                        <NavLink
                            to="profile"
                            className={navLinkClass}
                            onClick={() => setIsOpen(false)}
                            viewTransition={true}
                        >
                            <span className={navStyles.item__icon}>
                                <i className="fa-regular fa-user"></i>
                            </span>
                            <span className={navStyles.item__text}>{__('nav.dropup.profile')}</span>
                        </NavLink>
                        <NavLink
                            to="vehicles"
                            className={navLinkClass}
                            onClick={() => setIsOpen(false)}
                            viewTransition={true}
                        >
                            <span className={navStyles.item__icon}>
                                <i className="fa-light fa-car"></i>
                            </span>
                            <span className={navStyles.item__text}>{__('nav.dropup.vehicles')}</span>
                        </NavLink>
                        <NavLink
                            to="logout"
                            className={navLinkClass}
                            onClick={() => setIsOpen(false)}
                            viewTransition={true}
                        >
                            <span className={navStyles.item__icon}>
                                <i className="fa-light fa-power-off"></i>
                            </span>
                            <span className={navStyles.item__text}>{__('nav.dropup.logout')}</span>
                        </NavLink>
                    </>
                ) : (
                    <NavLink to="login" className={navLinkClass} viewTransition={true}>
                        {__('nav.dropup.login')}
                    </NavLink>
                )}
            </div>
        </div>
    );
}
